export default "__VITE_ASSET___$r$KVTw__"